import React, { useEffect, useState } from "react";
import useWindowSize from "../Hooks/useWindowSize";
import { AddFlex, CustomText } from "../reusableStyles";
import { CalendarMonth } from "@mui/icons-material";
import { headerTextColor } from "../constants";
import DropdownComponent from "../DropdownComponent";
import {
  getAdvanceBookingsSlots,
  getApiCallParams,
  isNullOrUndefined,
} from "../utils";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { usersApiCall } from "../Store/userSlice";
import { UserAvailabilityApi } from "../Api/ApiEndPoints";
import { enqueueSnackbar } from "notistack";

function AdvanceBookings() {
  const { isMobileView } = useWindowSize();
  const [inputValue, setInputValue] = useState(null);
  const apiUserData = useSelector((state) => state.user.apiUserData);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isNullOrUndefined(inputValue)) {
      return;
    }
    const interval = setTimeout(() => {
      dispatch(
        usersApiCall(
          getApiCallParams(UserAvailabilityApi, {
            data: inputValue,
            path: "availability.settings.advanceBooking",
          })
        )
      ).then((actionResult) => {
        if (actionResult.meta.requestStatus === "fulfilled") {
          enqueueSnackbar("Changes Saved Successfully", {
            variant: "success",
            anchorOrigin: {
              horizontal: "center",
              vertical: "bottom",
            },
          });
        } else {
          enqueueSnackbar("Something went wrong. Changes unsaved", {
            variant: "error",
            anchorOrigin: {
              horizontal: "center",
              vertical: "bottom",
            },
          });
        }
      });
    }, 1000);
    return () => {
      clearTimeout(interval);
    };
  }, [inputValue]);
  return (
    <AddFlex
      flexDirection={isMobileView() && "column"}
      width={isMobileView() ? "90%" : "70%"}
      justify="space-between"
      gap="10px"
    >
      <AddFlex width={isMobileView() ? "100%" : "50%"}>
        <CalendarMonth />
        <AddFlex flexDirection="column" gap="5px" margin="0 0 0 24px">
          <CustomText fontSize="18px" color={headerTextColor} fontWeight="500">
            Advance Bookings
          </CustomText>
          <CustomText color="black" fontWeight="300">
            How far in future can people book
          </CustomText>
        </AddFlex>
      </AddFlex>
      <div style={{ width: isMobileView() ? "100%" : "50%" }}>
        <DropdownComponent
          footerText={"Select from the dropdown"}
          initialValue={apiUserData.availability?.settings?.advanceBooking}
          getInputValue={(value) => {
            setInputValue(value);
          }}
          options={getAdvanceBookingsSlots()}
        />
      </div>
    </AddFlex>
  );
}

export default AdvanceBookings;
